// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_mz-0";
export var discountCodeInput = "_mz-1";